// components/events/CreateEvent.jsx
import React, { useMemo, useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import {
  arrayUnion,
  collection,
  doc,
  getDoc,
  serverTimestamp,
  writeBatch,
  updateDoc,
} from "firebase/firestore";
import {
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Row,
  Col,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// export default function CreateEvent({ communityId, onCreated }) {
export default function CreateEvent({
  communityId,
  onCreated,
  editEvent = null,
  mode = "create",
  onSuccess,
}) {
  const auth = useMemo(() => getAuth(), []);
  const managerUid = auth.currentUser?.uid || null;
  const navigate = useNavigate();
  const isEditMode =
  mode === "edit" &&
  editEvent?.id;

  const [showForm, setShowForm] = useState(false);
  const [checkingCommunity, setCheckingCommunity] = useState(false);
  const [communityError, setCommunityError] = useState("");
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState("");
  const [createSuccess, setCreateSuccess] = useState("");
  const [eventId, setEventId] = useState("");

  // Extended form state with entry fee details
  // const [eventForm, setEventForm] = useState({
  //   name: "",
  //   date: "",
  //   description: "",
  //   adultFee: "",
  //   childFee: "",
  //   freeBelowAge: "",
  // });
  const [eventForm, setEventForm] = useState({
  name: "",
  date: "",
  description: "",

  collectionMode: "individual", // individual | family

  adultFee: "",
  childFee: "",
  freeBelowAge: "",

  familyFee: "",
})

useEffect(() => {
  if (!isEditMode || !editEvent) return;

  setShowForm(true);

  setEventForm({
    name: editEvent.name || "",
    date: editEvent.date || "",
    description: editEvent.description || "",

    collectionMode:
      editEvent.collectionMode || "individual",

    adultFee:
      editEvent.entryFee?.adult || "",

    childFee:
      editEvent.entryFee?.child || "",

    freeBelowAge:
      editEvent.entryFee?.freeBelowAge || "",

    familyFee:
      editEvent.entryFee?.familyFee || "",
  });
}, [editEvent, isEditMode]);

  const resetFormState = () => {
    setCreateError("");
    setCreateSuccess("");
    setEventId("");
    // setEventForm({
    //   name: "",
    //   date: "",
    //   description: "",
    //   adultFee: "",
    //   childFee: "",
    //   freeBelowAge: "",
    // });
    setEventForm({
  name: "",
  date: "",
  description: "",

  collectionMode: "individual",

  adultFee: "",
  childFee: "",
  freeBelowAge: "",

  familyFee: "",
});
  };

  const openForm = () => {
    setCommunityError("");
    setCreateError("");
    setCreateSuccess("");
    setEventId("");
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
  };

  const validateCommunity = async () => {
    if (!communityId) {
      setCommunityError("Missing communityId.");
      return false;
    }
    setCommunityError("");
    setCheckingCommunity(true);
    try {
      const communityRef = doc(db, "communities", communityId);
      const snap = await getDoc(communityRef);
      if (!snap.exists()) {
        setCommunityError("Community not found.");
        return false;
      }
      return true;
    } catch (err) {
      console.error("Validate community error:", err);
      setCommunityError(err?.message || "Failed to validate community.");
      return false;
    } finally {
      setCheckingCommunity(false);
    }
  };

  const handleCreateEvent = async () => {
    setCreateError("");
    setCreateSuccess("");
    setEventId("");

    const { name, date, description, adultFee, childFee, freeBelowAge } = eventForm;

    if (!name.trim() || !date.trim()) {
      setCreateError("Event name and date are required.");
      return;
    }

    const ok = await validateCommunity();
    if (!ok) return;

    try {
      setCreating(true);

      const eventsCol = collection(db, "events");
      const eventRef = doc(eventsCol);

      const communityRef = doc(db, "communities", communityId);
      if (isEditMode) {
  await updateDoc(
    doc(db, "events", editEvent.id),
    {
      name: name.trim(),
      date: date.trim(),
      description: description?.trim() || "",

      collectionMode: eventForm.collectionMode,

      entryFee: {
        adult:
          eventForm.collectionMode === "individual"
            ? Number(adultFee || 0)
            : 0,

        child:
          eventForm.collectionMode === "individual"
            ? Number(childFee || 0)
            : 0,

        freeBelowAge:
          eventForm.collectionMode === "individual"
            ? Number(freeBelowAge || 0)
            : null,

        familyFee:
          eventForm.collectionMode === "family"
            ? Number(eventForm.familyFee || 0)
            : 0,
      },

      updatedAt: serverTimestamp(),
      updatedBy: managerUid || null,
    }
  );

  setCreateSuccess("Event updated successfully");

  if (onSuccess) {
    onSuccess();
  }

  return;
}
      const communitySnap = await getDoc(communityRef);
      let alsoPushIntoEventsAsStrings = false;
      if (communitySnap.exists()) {
        const cdata = communitySnap.data();
        if (Array.isArray(cdata.events) && cdata.events.every((x) => typeof x === "string")) {
          alsoPushIntoEventsAsStrings = true;
        }
      }

      const batch = writeBatch(db);

      const eventPayload = {
        id: eventRef.id,
        communityId,
        name: name.trim(),
        date: date.trim(),
        description: description?.trim() || "",
        committee: [],
        createdAt: serverTimestamp(),
        createdBy: managerUid || null,
        status: "scheduled",
        // entryFee: {
        //   adult: adultFee ? Number(adultFee) : 0,
        //   child: childFee ? Number(childFee) : 0,
        //   freeBelowAge: freeBelowAge ? Number(freeBelowAge) : null,
        // },
        collectionMode: eventForm.collectionMode,

entryFee: {
  adult:
    eventForm.collectionMode === "individual"
      ? Number(adultFee || 0)
      : 0,

  child:
    eventForm.collectionMode === "individual"
      ? Number(childFee || 0)
      : 0,

  freeBelowAge:
    eventForm.collectionMode === "individual"
      ? Number(freeBelowAge || 0)
      : null,

  familyFee:
    eventForm.collectionMode === "family"
      ? Number(eventForm.familyFee || 0)
      : 0,
},
      };

      batch.set(eventRef, eventPayload);

      const updates = { eventIds: arrayUnion(eventRef.id) };
      if (alsoPushIntoEventsAsStrings) {
        updates["events"] = arrayUnion(eventRef.id);
      }
      batch.update(communityRef, updates);

      await batch.commit();

      setEventId(eventRef.id);
      setCreateSuccess(`Event created: ${eventRef.id}`);
      closeForm();

      if (typeof onCreated === "function") {
        onCreated(eventRef.id);
      }
    } catch (err) {
      console.error("Create event error:", err);
      setCreateError(err?.message || "Failed to create event.");
    } finally {
      setCreating(false);
      resetFormState();
    }
  };

  const goToCommittee = () => {
    if (!eventId) return;
    navigate(`/events/${eventId}/committee`);
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <strong>Community Events</strong>
        <Button
          variant="primary"
          size="sm"
          onClick={openForm}
          disabled={checkingCommunity || creating || showForm}
        >
          + Add Event
        </Button>
      </Card.Header>

      <Card.Body>
        {communityError && <Alert variant="danger">{communityError}</Alert>}

        {showForm && (
          <Card className="mb-3">
            <Card.Header>
              {/* <strong>Create Event</strong> */}
              <strong>
  {isEditMode
    ? "Edit Event"
    : "Create Event"}
</strong>
            </Card.Header>
            <Card.Body>
              <Row className="g-2 align-items-end">
                <Col md={4}>
                  <Form.Label>Event Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={eventForm.name}
                    onChange={(e) => setEventForm((s) => ({ ...s, name: e.target.value }))}
                  />
                </Col>

                <Col md={3}>
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={eventForm.date}
                    onChange={(e) => setEventForm((s) => ({ ...s, date: e.target.value }))}
                  />
                </Col>

                <Col md={5}>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    value={eventForm.description}
                    onChange={(e) => setEventForm((s) => ({ ...s, description: e.target.value }))}
                  />
                </Col>

                {/* Entry Fee Section */}
                {/* <Col md={4}>
                  <Form.Label>Adult Fee</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="e.g., 100"
                    value={eventForm.adultFee}
                    onChange={(e) => setEventForm((s) => ({ ...s, adultFee: e.target.value }))}
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Child Fee</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="e.g., 50"
                    value={eventForm.childFee}
                    onChange={(e) => setEventForm((s) => ({ ...s, childFee: e.target.value }))}
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Free Below Age</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="e.g., 5"
                    value={eventForm.freeBelowAge}
                    onChange={(e) => setEventForm((s) => ({ ...s, freeBelowAge: e.target.value }))}
                  />
                </Col> */}

                {/* Collection Mode */}
<Col md={12}>
  <Form.Label>Collection Mode</Form.Label>

  <div>
    <Form.Check
      inline
      type="radio"
      name="collectionMode"
      id="individual-mode"
      label="Individual Fee"
      checked={eventForm.collectionMode === "individual"}
      onChange={() =>
        setEventForm((s) => ({
          ...s,
          collectionMode: "individual",
        }))
      }
    />

    <Form.Check
      inline
      type="radio"
      name="collectionMode"
      id="family-mode"
      label="Family Fee"
      checked={eventForm.collectionMode === "family"}
      onChange={() =>
        setEventForm((s) => ({
          ...s,
          collectionMode: "family",
        }))
      }
    />
  </div>
</Col>

{/* Individual Collection */}
{eventForm.collectionMode === "individual" ? (
  <>
    <Col md={4}>
      <Form.Label>Adult Fee</Form.Label>
      <Form.Control
        type="number"
        placeholder="e.g., 100"
        value={eventForm.adultFee}
        onChange={(e) =>
          setEventForm((s) => ({
            ...s,
            adultFee: e.target.value,
          }))
        }
      />
    </Col>

    <Col md={4}>
      <Form.Label>Child Fee</Form.Label>
      <Form.Control
        type="number"
        placeholder="e.g., 50"
        value={eventForm.childFee}
        onChange={(e) =>
          setEventForm((s) => ({
            ...s,
            childFee: e.target.value,
          }))
        }
      />
    </Col>

    <Col md={4}>
      <Form.Label>Free Below Age</Form.Label>
      <Form.Control
        type="number"
        placeholder="e.g., 5"
        value={eventForm.freeBelowAge}
        onChange={(e) =>
          setEventForm((s) => ({
            ...s,
            freeBelowAge: e.target.value,
          }))
        }
      />
    </Col>
  </>
) : (
  /* Family Collection */
  <Col md={4}>
    <Form.Label>Family Fee</Form.Label>
    <Form.Control
      type="number"
      placeholder="e.g., 500"
      value={eventForm.familyFee}
      onChange={(e) =>
        setEventForm((s) => ({
          ...s,
          familyFee: e.target.value,
        }))
      }
    />
  </Col>
)}

                <Col xs={12} className="mt-2 d-flex gap-2">
                  {/* <Button variant="success" onClick={handleCreateEvent} disabled={creating}>
                    {creating ? "Creating…" : "Create Event"}
                  </Button> */}
                  <Button
  variant="success"
  onClick={handleCreateEvent}
  disabled={creating}
>
  {creating
    ? (
        isEditMode
          ? "Updating..."
          : "Creating..."
      )
    : (
        isEditMode
          ? "Update Event"
          : "Create Event"
      )
  }
</Button>
                  <Button variant="outline-secondary" onClick={closeForm} disabled={creating}>
                    Cancel
                  </Button>
                </Col>
              </Row>

              {createError && <Alert variant="danger">{createError}</Alert>}
              {createSuccess && (
                <Alert variant="success" className="mt-3 d-flex justify-content-between">
                  <span>{createSuccess}</span>
                  <Button size="sm" variant="outline-success" onClick={goToCommittee}>
                    Manage Committee
                  </Button>
                </Alert>
              )}
            </Card.Body>
          </Card>
        )}
      </Card.Body>
    </Card>
  );
}
